import { render, staticRenderFns } from "./StockDistant.vue?vue&type=template&id=45b8011e&"
import script from "./StockDistant.vue?vue&type=script&lang=js&"
export * from "./StockDistant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports